hidePrice()

function hidePrice() {
  const element = document.querySelector(
    "[bss-b2b-product-form='main'] [bss-b2b-variant-price]"
  );
  const eleTotal = document.querySelector("[data-button-price]");

  if (element) element.classList.add("bss-hide-price");
  if (eleTotal) eleTotal.classList.add("bss-hide-price");

  let counter = 0;
  const interval = setInterval(() => {
      if (BSS_B2B?.storage?.variantStorage) {
        const el = document.querySelector("[bss-b2b-variant-id]");
          const variantId = el?.getAttribute("bss-b2b-variant-id");
            const variantInfo = BSS_B2B.storage.variantStorage.get(Number(variantId)) 
            if (!variantInfo) return;
            if (!variantInfo.appliedQB) {
              const currentPrice =
                variantInfo.bssB2BPriceAfterPL ||
                variantInfo.price; 
              
              const input = document.querySelector("[data-quantity-input]");

              if (input) {
                const total = Math.round(currentPrice * Number(input.value));

                const eleTotal = document.querySelector("[data-button-price]");
                if (eleTotal) {
                  eleTotal.innerHTML = `<span style="color: #000000;">${BSS_B2B.formatMoney(total)}</span>`;
                }

                setTimeout(() => {
                  showPrice();
                }, 1200);
              }
            }
          clearInterval(interval);
      } else {
          counter += 100;
          if (counter >= 10000) {
              clearInterval(interval);
          }
      }
  }, 100); 
}

function showPrice() {
  const element = document.querySelector(
    "[bss-b2b-product-form='main'] [bss-b2b-variant-price]"
  );

  const eleTotal = document.querySelector("[data-button-price]");

  if (element) element.classList.remove("bss-hide-price");
  if (eleTotal) eleTotal.classList.remove("bss-hide-price");

}

document.addEventListener(
  'blur',
  e => {
    if (e.target.matches('input[data-quantity-input]')) {
      hidePrice();
    }
  },
  true
);

document.addEventListener('keydown', e => {
  if (
    e.key === 'Enter' &&
    e.target.matches('input[data-quantity-input]')
  ) {
    hidePrice();
  }
});

document.addEventListener("click", (e) => {
  const item = e.target.closest(".select-popout__item");
  if (!item) return;
  hidePrice();
});


document.addEventListener('click', e => {
  const btn = e.target.closest('.quantity__button');
  if (!btn) return;

  const wrapper = btn.closest('.quantity__wrapper');
  const input = wrapper.querySelector('input[data-quantity-input]');
  if (input) {
    hidePrice();
  }
});

const products = document.querySelectorAll("[bss-b2b-product-price]");

  products.forEach(el => {
    el.style.display = "none";
  });

  setTimeout(() => {
    products.forEach(el => {
      el.style.display = "block";
    });
  }, 3000);



window.bssB2BHooks = window.bssB2BHooks || {
  actions: {},
  filters: {},
};
window.BSS_B2B = window.BSS_B2B || {};
window.BSS_B2B.addAction = (tag, callback) => {
  window.bssB2BHooks.actions[tag] = callback;
};
window.BSS_B2B.addFilter = (tag, value) => {
  window.bssB2BHooks.filters[tag] = value;
};
const funcHandle = ({ a, b, c}) => {
  // handle something
};
window.BSS_B2B.addAction("handleSomething", funcHandle ); 
/*────────────────────────────────────╮
│ Change price QB in PDP              │
│ ** User: tungnv@bsscommerce.com **  │
│ ** Created at : 08/01/2026 11:28 ** │
│ ** Updated at : 08/01/2026 11:28 ** │
╰────────────────────────────────────*/
(() => {
        let calculateDiscountQB = (price, type, value) => {
        const rateMarket = Number(window.Shopify.currency.rate) || 1;
        let modifiedPrice = price;
        let discountValue = 0;
        const priceWithStoreCurrency = price / rateMarket;
        switch (type) {
            case 0:
                value = value * 100;
                if (value < priceWithStoreCurrency) {
                    discountValue = parseFloat(((priceWithStoreCurrency - value) / 100).toFixed(2));
                    discountValue = parseFloat((discountValue * rateMarket).toFixed(2)) * 100;
                    modifiedPrice = Math.round((price - discountValue) * 100) / 100;
                }
                break;
            case 1:
                discountValue = value * rateMarket * 100;
                modifiedPrice = price > discountValue ? price - discountValue : 0;
                break;
            case 2:
                discountValue = parseFloat(((priceWithStoreCurrency * value) / 100).toFixed(2));
                discountValue = parseFloat((discountValue * rateMarket).toFixed(2));
                modifiedPrice = price - discountValue;
                break;
            default:
                break;
        }
        return modifiedPrice;
    }
    
    
    const changeQBPrice = (appliedItem) => {
        let priceFinal = 0;
        const element = document.querySelector("[bss-b2b-product-form='main'] [bss-b2b-variant-price]");
        if (element) {
            const variant_id = element.getAttribute('bss-b2b-variant-id');
            const variantStorage = BSS_B2B.storage.variantStorage.get(parseInt(variant_id));
            let originPriceAfterCP = BSS_B2B.utils.getModifyPrice(variantStorage, 'qb');
            if (!originPriceAfterCP) {
                originPriceAfterCP = BSS_B2B.storage.variantStorage.store.get(parseInt(variant_id)).price;
            }
            priceFinal = originPriceAfterCP;
            if (appliedItem) {
                const newQBPrice = calculateDiscountQB(originPriceAfterCP, appliedItem.discount_type, appliedItem.discount_value);
                priceFinal = newQBPrice;
                setTimeout(() => {
                    if(!variantStorage.appliedTD) {
                        element.innerHTML = `<span style="color: #000000;">${BSS_B2B.formatMoney(newQBPrice)}</span>`;
                    }
                    const input = document.querySelector("[data-quantity-input]");
                    if(input) {
                      hidePrice();
                      const total = Math.round(newQBPrice * Number(input.value)); 
                      const eleTotal = document.querySelector("[data-button-price]");
                      if(eleTotal) {
                        eleTotal.innerHTML = `<span style="color: #000000;">${BSS_B2B.formatMoney(total)}</span>`;
                      }

                      const products = document.querySelectorAll("[bss-b2b-product-price]");
                        products.forEach(el => {
                          el.style.display = "none";
                      });
                      setTimeout(() => {
                          products.forEach(el => {
                            el.style.display = "block";
                          });
                        showPrice();
                      }, 1000);
                    }
                }, 450)
            }
    
    
            if (variantStorage?.appliedTD) {
                setTimeout(() => {
                    const priceAfterTD = variantStorage.bssB2BPriceAfterTD;
                    if (priceAfterTD) {
                        if (!priceAfterTD?.priceNoVat) return;
                        priceAfterTD.priceNoVat = priceFinal;
                        priceAfterTD.priceHasVat = priceFinal;
                        const taxable = variantStorage.taxable;
                        const taxRate = BSS_B2B.countryTax;
                        if (taxable) {
                            const basePrice = priceFinal; 
                            if (BSS_B2B.shopData.taxes_included) {
                                priceAfterTD.priceNoVat = basePrice / (1 + taxRate);
                                priceAfterTD.priceHasVat = basePrice;
                            } else {
                                priceAfterTD.priceNoVat = basePrice;
                                priceAfterTD.priceHasVat = basePrice * (1 + taxRate);
                            }
                        }
                        const {
                            priceHasVat,
                            priceNoVat,
                            comparePriceHasVat,
                            comparePriceNoVat
                        } = BSS_B2B.td.utils.product.getPriceHtml(
                            variantStorage?.appliedTD,
                            priceAfterTD,
                            1
                        );
                        element.innerHTML = priceNoVat + priceHasVat;
                    }
                }, 100);

    
            }
        }
    }
    window.BSS_B2B.addAction('custom:product/change_qb_price', changeQBPrice);
})();

if(window.location.pathname.includes("/cart")) {
  setTimeout(() => {
    BSS_B2B.observer.cartSubject.notifyObserver('CartUpdate', 'CartMutate');
  }, 500);
}